type SlideEl = HTMLElement;

const lcpBanner = {
  slider: document.querySelector('.heroSlider') as HTMLElement | null,

  init() {
    if (!this.slider) return;

    const slides = Array.from(this.slider.querySelectorAll('.hero__single')) as SlideEl[];
    if (slides.length <= 1) return;

    let index = 0;

    const lazyLoad = (slide: SlideEl | undefined) => {
      if (!slide) return;

      const img = slide.querySelector('img.hero__img') as HTMLImageElement | null;
      if (img?.dataset.src) {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      }

      slide.querySelectorAll('source').forEach((s) => {
        const source = s as HTMLSourceElement;
        if (source.dataset.srcset) {
          source.srcset = source.dataset.srcset;
          source.removeAttribute('data-srcset');
        }
      });
    };

    const preload = (i: number) => {
      if (i < 0 || i >= slides.length) return;
      lazyLoad(slides[i]);
    };

    // ---------- Controls ----------
    const controls = document.createElement('div');
    controls.className = 'hero__controls';
    controls.setAttribute('role', 'group');
    controls.setAttribute('aria-label', 'Hero carousel controls');

    const dots = document.createElement('div');
    dots.className = 'hero__pagination';
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', 'Hero slide pagination');

    const ICON_PLAY = `
      <svg aria-hidden="true" focusable="false">
        <use xlink:href="#icon-play"></use>
      </svg>
    `;
    const ICON_PAUSE = `
      <svg aria-hidden="true" focusable="false">
        <use xlink:href="#icon-pause"></use>
      </svg>
    `;

    const toggleBtn = document.createElement('button');
    toggleBtn.type = 'button';
    toggleBtn.className = 'hero__toggle';

    controls.appendChild(dots);
    controls.appendChild(toggleBtn);
    this.slider.appendChild(controls);

    const dotButtons = slides.map((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'hero__dot';
      b.setAttribute('aria-label', `Go to slide ${i + 1}`);
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');

      b.addEventListener('click', () => {
        setAutoplayEnabled(false);
        showSlide(i);
      });

      dots.appendChild(b);
      return b;
    });

    const updateDots = () => {
      dotButtons.forEach((b, i) => {
        const active = i === index;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };

    // ---------- Slide switching ----------
    const showSlide = (newIndex: number) => {
      if (newIndex === index) return;

      slides[index].style.opacity = '0';
      slides[index].style.visibility = 'hidden';

      preload(newIndex);

      slides[newIndex].style.opacity = '1';
      slides[newIndex].style.visibility = 'visible';

      index = newIndex;
      updateDots();

      // preload neighbors
      preload((index + 1) % slides.length);
      preload((index - 1 + slides.length) % slides.length);
    };

    // ---------- Autoplay ----------
    const AUTOPLAY_MS = 6000;
    let timer: number | null = null;

    let autoplayEnabled = true;
    let holdPaused = false;

    const setToggleUI = () => {
      if (autoplayEnabled) {
        toggleBtn.innerHTML = ICON_PAUSE;
        toggleBtn.setAttribute('aria-label', 'Pause autoplay');
        toggleBtn.setAttribute('aria-pressed', 'false');
      } else {
        toggleBtn.innerHTML = ICON_PLAY;
        toggleBtn.setAttribute('aria-label', 'Play autoplay');
        toggleBtn.setAttribute('aria-pressed', 'true');
      }
    };

    const startTimer = () => {
      if (!autoplayEnabled || timer) return;

      timer = window.setInterval(() => {
        if (holdPaused) return;
        showSlide((index + 1) % slides.length);
      }, AUTOPLAY_MS);
    };

    const stopTimer = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const setAutoplayEnabled = (enabled: boolean) => {
      autoplayEnabled = enabled;
      setToggleUI();
      if (autoplayEnabled) startTimer();
      else stopTimer();
    };

    toggleBtn.addEventListener('click', () => setAutoplayEnabled(!autoplayEnabled));

    // Hover hold
    this.slider.addEventListener('mouseenter', () => (holdPaused = true));
    this.slider.addEventListener('mouseleave', () => (holdPaused = false));

    // Focus hold (ignore focus inside controls)
    this.slider.addEventListener('focusin', (e) => {
      const target = e.target as HTMLElement | null;
      if (target?.closest('.hero__controls')) return;
      holdPaused = true;
    });

    this.slider.addEventListener('focusout', (e) => {
      const target = e.target as HTMLElement | null;
      if (target?.closest('.hero__controls')) return;

      const related = (e as FocusEvent).relatedTarget as HTMLElement | null;
      if (!this.slider?.contains(related)) holdPaused = false;
    });

    updateDots();
    setToggleUI();
    startTimer();
    preload(1);
    preload(slides.length - 1);
  }
};

export default lcpBanner;


